var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCaret = props => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "Ebene 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 5.81 9.56"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  className: "caret_svg__cls-1",
  x: 1801.03,
  y: 249.33,
  width: 2.07,
  height: 7.36,
  rx: 1.03,
  transform: "rotate(-45 600.575 2299.744)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  className: "caret_svg__cls-1",
  x: 1798.39,
  y: 255.73,
  width: 7.36,
  height: 2.07,
  rx: 1.03,
  transform: "rotate(-45 600.578 2303.493)"
})));

export default SvgCaret;